import hisrequest from '@/utils/hisrequest'
import { getHospital } from '@/services/inst.service'

/**
 * 获取 HDIS 查询请求的 baseURL
 * 优先使用 hdisApiUrl，若为空则回退到 hisLocalServiceUrl
 */
function getHdisBaseUrl() {
  const hospital = getHospital()
  if (!hospital) return ''
  return hospital.hdisApiUrl || hospital.hisLocalServiceUrl || ''
}

/**
 * 获取 HDIS 同步（写入）请求的 baseURL
 * 优先使用 hdisSyncApiUrl，若为空则回退到 hdisApiUrl → hisLocalServiceUrl
 */
function getHdisSyncBaseUrl() {
  const hospital = getHospital()
  if (!hospital) return ''
  return hospital.hdisSyncApiUrl || hospital.hdisApiUrl || hospital.hisLocalServiceUrl || ''
}

/**
 * 发送 HDIS 查询请求（走 hdisApiUrl）
 * @param {Object} config - axios 请求配置
 */
function hdisRequest(config) {
  const baseUrl = getHdisBaseUrl()
  if (baseUrl) {
    config.baseURL = baseUrl
  }
  return hisrequest(config)
}

/**
 * 发送 HDIS 同步写入请求（走 hdisSyncApiUrl）
 * @param {Object} config - axios 请求配置
 */
function hdisSyncRequest(config) {
  const baseUrl = getHdisSyncBaseUrl()
  if (baseUrl) {
    config.baseURL = baseUrl
  }
  return hisrequest(config)
}

/**
 * 查询 HDIS 患者列表
 * @param {Object} params - { patientName, cardNum, dialysisId, state, pageSize, pageIndex }
 */
export function hdisListPatients(params, { ignoreNotFound = false } = {}) {
  return hdisRequest({
    url: '/hdis/patients',
    method: 'get',
    params,
    // 仅登录后台同步允许医院尚未部署该接口；手动查询仍提示错误。
    _ignoreNotFound: ignoreNotFound
  })
}

/**
 * 根据 HDIS 主键 ID 获取患者详情
 * @param {string} id - HDIS 患者 ID
 */
export function hdisGetPatient(id) {
  return hdisRequest({
    url: `/hdis/patients/${id}`,
    method: 'get'
  })
}

/**
 * 获取 HDIS 患者透析处方列表
 * @param {string} patientId - HDIS 患者 ID
 */
export function hdisGetPrescriptions(patientId) {
  return hdisRequest({
    url: `/hdis/patients/${patientId}/prescriptions`,
    method: 'get'
  })
}

/**
 * 获取 HDIS 患者医嘱列表
 * @param {string} patientId - HDIS 患者 ID
 * @param {Object} params - { orderSource, state, pageSize, pageIndex }
 */
export function hdisGetOrders(patientId, params) {
  return hdisRequest({
    url: `/hdis/patients/${patientId}/orders`,
    method: 'get',
    params
  })
}

/**
 * 推送医嘱到 HDIS
 * @param {Array} adviceList - 医嘱明细列表（HDIS格式）
 */
export function hdisAddDoctorAdvice(adviceList) {
  return hdisSyncRequest({
    url: '/api/InterfaceSync/AddDoctorAdvice',
    method: 'post',
    data: adviceList
  })
}

/**
 * 同步 HIS 药品信息到 HDIS 药品字典表
 * @param {Object} syncData - { items: [...], createUserId: 'HIS_SYSTEM' }
 */
export function hdisSyncDrugs(syncData) {
  return hdisRequest({
    url: '/hdis/drugs/sync',
    method: 'post',
    data: syncData
  })
}
